import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { Button, Grid } from '@frontierag/frontier-ui-library';
import { ChevronLeft as ChevronLeftIcon } from '@frontierag/frontier-ui-library/icons';
import { useApp } from 'contexts/App';

interface IChooseProductTypeProps {
  translationNamespace: string;
}

const ChooseProductType = ({ translationNamespace }: IChooseProductTypeProps) => {
  const { t } = useTranslation(translationNamespace);

  const navigate = useNavigate();
  const {
    state: { isGroupUser },
    actions: { resetApplicationType },
  } = useApp();

  const onClick = useCallback(() => {
    resetApplicationType();
    navigate('/');
  }, [navigate, resetApplicationType]);

  return (
    <Grid container item mt={{ xs: 2, sm: 14 }} justifyContent="center">
      {!isGroupUser && (
        <Button startIcon={<ChevronLeftIcon />} onClick={onClick}>
          {t('resetProductType')}
        </Button>
      )}
    </Grid>
  );
};

export default ChooseProductType;
